import { observer } from "mobx-react-lite";

import { ReferenceTabs } from "../../../components/admin-console/reference-tabs";
import { useReferenceDictionaries } from "../hooks/use-reference-dictionaries";
import { usePageStore } from "../reference-document-types-page.lib";

/** Табы «Справочники»: активная вкладка в сторе, счётчик «Виды работ» — из справочника. */
export const DocumentTypesTabs = observer(() => {
  const store = usePageStore()!;
  const { plannedWorksTypes, isLoading } = useReferenceDictionaries();

  return (
    <ReferenceTabs
      activeKey={store.activeTab}
      onChange={(tab) => store.setActiveTab(tab)}
      workTypesCount={isLoading ? undefined : plannedWorksTypes.length}
    />
  );
});
